/**
 *
 * DASHBOARD-SUMMARIZE
 * summarize survey messages with chatGPT
 *
 */
import ConsentOpenaiWidget from "./consent-openai.widget"
import GptDisplayerWidget from "./gpt-displayer.widget"
import { Question } from "@/redux/question.types"
import { Session } from "@/redux/_session.types"
import { connect } from "react-redux"
import { flatten } from "lodash"
import { TopicState } from "@/redux/topic.types"

interface StateProps {
  _session: Session
  topic: TopicState
}

interface OwnProps {
  comments: string[]
  currentQuestion: Question
}

type Props = OwnProps & StateProps

function DashboardSummarizeWidget(props: Props) {
  const isPromptCustom = props.currentQuestion.isPromptCustom
  const prompt = props.currentQuestion.getPromptFormatted(
    props.comments,
    props._session.userInitialLanguage,
    props.currentQuestion.label
  )

  let label = ""
  const questionPrimary = flatten(props.topic.list.map((x) => x.Questions)).find(
    (x) => x.id === props.currentQuestion.primaryId
  )

  if (questionPrimary) {
    label = questionPrimary.label + " - " + props.currentQuestion.label
  } else {
    label = props.currentQuestion.label
  }

  return (
    <ConsentOpenaiWidget>
      <GptDisplayerWidget
        destination={isPromptCustom ? "ask" : "summarize"}
        params={{
          comments: props.comments,
          label,
          prompt,
          useBullets: questionPrimary ? false : true
        }}
        language={props._session.language}
      />
    </ConsentOpenaiWidget>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session,
  topic: state.topic
})

export default connect(mapStateToProps)(DashboardSummarizeWidget)
